import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import routes from '../../../routes';
import SignupForm from './SignupForm';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const SignupCard = (props) => {
  const { getTranslation, getAppLocale } = useTranslation('AUTH');
  const { t } = getTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralParam = queryParams.get('referral');

  const locale = getAppLocale();

  const getTermsAgreeTexts = () => {
    if (locale === 'en') {
      return (
        <>
          By clicking on <strong> signup </strong> you agree with Raychat's{' '}
          <a href='https://raychat.io/license' rel='noreferrer' target='_blank'>
            terms of use
          </a>
        </>
      );
    }

    return (
      <>
        با کلیک بر روی
        <strong> " عضویت" </strong>
        با
        <a rel='noreferrer' href='https://raychat.io/license' target='_blank'>
          شرایط استفاده
        </a>
        رایچت موافقت می‌کنید.
      </>
    );
  };

  return (
    <div className='signup_box'>
      <h4>{t('SIGNUP_HEADER_TITLE')}</h4>
      <p>
        {' '}
        {t('SIGNUP_ALREADY_ACCOUNT')}{' '}
        <span>
          <Link
            to={
              Boolean(referralParam)
                ? `${routes.login}?referral=${referralParam}`
                : routes.login
            }
          >
            {t('SIGNUP_LOGIN_LINK')}
          </Link>
        </span>
      </p>
      <SignupForm />
      <div className='license'>
        <p>{getTermsAgreeTexts()}</p>
      </div>
    </div>
  );
};

export default SignupCard;
